// features/ApprovalRequest/ApprovalRequestAddEditView/base.tsx
import React, { FC, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Paper,
  Grid,
  Box,
  Container,
  MenuItem,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import store from "./store";
import { observer } from "mobx-react";
import LookUp from 'components/LookUp';
import CustomTextField from "components/TextField";
import DateField from "components/DateField";
import { Button, Stack, Typography } from "@mui/material";

type ApprovalRequestBaseProps = {
  children?: React.ReactNode;
  isPopup?: boolean;
};

const ApprovalRequestBaseView: FC<ApprovalRequestBaseProps> = observer((props) => {
  useEffect(() => {
    console.log(store.current_status);
  }, [store.current_status]);
  const { t } = useTranslation();
  const translate = t;

  return (
    <Container maxWidth='xl' sx={{ mt: 3 }} style={{ marginTop: 20, marginBottom: 20 }}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography>
          Текущий статус: <b>{store.statuses.find(s => s.code === store.current_status)?.name}</b>
        </Typography>
          {(!store.disableEdit && store.nextStatuses()?.length > 0) && <Typography>Изменить статус на:</Typography>}
        {store.nextStatuses().map(code => (
          <Button
            key={code}
            variant="contained"
            onClick={() => {
              store.changeStatus(code);
            }}
          >
            {store.statuses.find(s => s.code === code)?.name}
          </Button>
        ))}
      </Stack>
      <Grid container>
        <form id="ApprovalRequestForm" autoComplete='off'>
          <Paper elevation={7}>
            <Card>
              <CardHeader title={
                <span id="ApprovalRequest_TitleName">
                  {translate('label:ApprovalRequestAddEditView.entityTitle')}
                </span>
              } />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      disabled
                      helperText={store.errorbga_application_number}
                      error={store.errorbga_application_number != ''}
                      id='id_f_ApprovalRequest_bga_application_number'
                      label={translate('label:ApprovalRequestAddEditView.bga_application_number')}
                      value={store.bga_application_number}
                      onChange={(event) => store.handleChange(event)}
                      name="bga_application_number"
                    />
                  </Grid>

                  {/* <Grid item md={6} xs={12}>
                    <LookUp
                      helperText={store.errororganization_id}
                      error={store.errororganization_id != ''}
                      id='id_f_ApprovalRequest_organization_id'
                      label={translate('label:ApprovalRequestAddEditView.organization_id')}
                      value={store.organization_id}
                      onChange={(event) => store.handleChange(event)}
                      name="organization_id"
                      data={store.organisation}
                      required
                    />
                  </Grid> */}

                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      disabled
                      helperText={store.errorapplicant_name}
                      error={store.errorapplicant_name != ''}
                      id='id_f_ApprovalRequest_applicant_name'
                      label={translate('label:ApprovalRequestAddEditView.applicant_name')}
                      value={store.applicant_name}
                      onChange={(event) => store.handleChange(event)}
                      name="applicant_name"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      disabled
                      helperText={store.errorapproval_type}
                      error={store.errorapproval_type != ''}
                      id='id_f_ApprovalRequest_approval_type'
                      label={translate('label:ApprovalRequestAddEditView.approval_type')}
                      value={store.approval_type}
                      onChange={(event) => store.handleChange(event)}
                      name="approval_type"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      //   select 
                      disabled
                      helperText={store.errorpriority}
                      error={store.errorpriority != ''}
                      id='id_f_ApprovalRequest_priority'
                      label={translate('label:ApprovalRequestAddEditView.priority')}
                      value={store.priority}
                      onChange={(event) => store.handleChange(event)}
                      name="priority"
                    />
                    {/* {priorityOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </CustomTextField> */}
                  </Grid>

                  {/* <Grid item md={6} xs={12}>
                    <LookUp
                      helperText={store.erroroperator_id}
                      error={store.erroroperator_id != ''}
                      id='id_f_ApprovalRequest_operator_id'
                      label={translate('label:ApprovalRequestAddEditView.operator_id')}
                      value={store.operator_id}
                      onChange={(event) => store.handleChange(event)}
                      name="operator_id"
                      data={store.operators}
                    />
                  </Grid> */}

                  <Grid item md={6} xs={12}>
                    <DateField
                      disabled
                      label={translate('label:ApprovalRequestAddEditView.received_date')}
                      value={store.received_date}
                      onChange={(event) => store.handleChange(event)}
                      name="received_date"
                      id='id_f_ApprovalRequest_received_date'
                      helperText={store.errorreceived_date}
                      error={!!store.errorreceived_date}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <DateField
                      disabled
                      label={translate('label:ApprovalRequestAddEditView.deadline_date')}
                      value={store.deadline_date}
                      onChange={(event) => store.handleChange(event)}
                      name="deadline_date"
                      id='id_f_ApprovalRequest_deadline_date'
                      helperText={store.errordeadline_date}
                      error={!!store.errordeadline_date}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <DateField
                      disabled
                      label={translate('label:ApprovalRequestAddEditView.completed_date')}
                      value={store.completed_date}
                      onChange={(event) => store.handleChange(event)}
                      name="completed_date"
                      id='id_f_ApprovalRequest_completed_date'
                      helperText={store.errorcompleted_date}
                      error={!!store.errorcompleted_date}
                    />
                  </Grid>
                    <Grid item md={6} xs={12}>
                        <CustomTextField
                            disabled
                            helperText={store.errordescription}
                            error={store.errordescription != ''}
                            id='id_f_ApprovalRequest_applicant_name'
                            label={translate('label:ApprovalRequestAddEditView.description')}
                            value={store.description}
                            onChange={(event) => store.handleChange(event)}
                            name="description"
                        />
                    </Grid>

                </Grid>
              </CardContent>
            </Card>
          </Paper>
        </form>
      </Grid>
      {props.children}
    </Container>
  );
});

export default ApprovalRequestBaseView;